<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    xmlns:xlink="http://www.w3.org/1999/xlink"
    fill="none"
    version="1.1"
    width="16"
    height="16"
    viewBox="0 0 16 16"
  >
    <g style="mix-blend-mode: passthrough">
      <g style="mix-blend-mode: passthrough">
        <path
          d="M11,7C11,7,9,7,9,7C9,7,9,5,9,5C9,4.45,8.55,4,8,4C7.45,4,7,4.45,7,5C7,5,7,7,7,7C7,7,5,7,5,7C4.45,7,4,7.45,4,8C4,8.55,4.45,9,5,9C5,9,7,9,7,9C7,9,7,11,7,11C7,11.55,7.45,12,8,12C8.55,12,9,11.55,9,11C9,11,9,9,9,9C9,9,11,9,11,9C11.55,9,12,8.55,12,8C12,7.45,11.55,7,11,7C11,7,11,7,11,7Z"
          fill-rule="evenodd"
          fill="currentColor"
        />
      </g>
    </g>
  </svg>
</template>
<script lang="ts">
import type { DefineComponent } from 'vue'
export default {
  name: 'SmallPlus',
} as DefineComponent
</script>
